var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field checkboxes checkboxes--inline field--full",class:{ 'required': _vm.required }},[_c('div',{staticClass:"heading"},[_c('legend',[_c('span',{staticClass:"legend-text"},[_vm._v(_vm._s(_vm.heading))])])]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }